import type {FilteredItemsPageUrlQueryParams} from '@frontend/modules/public/ads/AdsModuleTypes'
import {useAdsStore} from '@frontend/stores'
import type {
    MouseEvent,
    SubmitEvent,
} from 'react'
import {useEventCallback} from 'swayok-react-mdb-ui-kit/helpers/useEventCallback'
import {useUrlQueryParams} from 'swayok-react-mdb-ui-kit/helpers/useUrlQueryParams'
import {NavigationService} from 'swayok-react-mdb-ui-kit/services/NavigationService'
import type {AnyObject} from 'swayok-react-mdb-ui-kit/types/Common'

type HookReturnFn = (
    event?: SubmitEvent<HTMLFormElement> | MouseEvent<HTMLElement>,
    filters?: AnyObject
) => void

// Возвращает обработчик события для отправки формы поиска ключевых слов.
export function useItemsSearchKeywordsSubmitHandler(): HookReturnFn {
    const store = useAdsStore()
    // Данные о текущем URL.
    const {
        urlQueryParams,
        urlQueryData,
    } = useUrlQueryParams<FilteredItemsPageUrlQueryParams>()
    // Нажатие кнопки "Найти" для ключевых слов.
    return useEventCallback((
        event?: SubmitEvent<HTMLFormElement> | MouseEvent<HTMLElement>,
        filters?: AnyObject
    ): void => {
        event?.preventDefault?.()
        if (store.isSearchPanelDisabled) {
            return
        }
        // Блокировка повторных запросов на небольшое время, чтобы предотвратить спам.
        store.setIsSearchPanelDisabled(true)
        setTimeout(() => store.setIsSearchPanelDisabled(false), 1500)
        // Собираем URL query для перехода на страницу объявлений или услуг.
        const queryParams: Partial<FilteredItemsPageUrlQueryParams> = urlQueryParams.has('location')
            // Это страница с объявлениями: изменяем только ключевые слова в URL Query.
            ? urlQueryData
            // Собираем новый URL Query.
            : {}
        delete queryParams.keywords
        if (filters) {
            if ('props' in queryParams) {
                let oldFilters = {}
                try {
                    oldFilters = JSON.parse(queryParams.props ?? '{}')
                } catch (_e) {
                }
                filters = {
                    ...oldFilters,
                    ...filters,
                }
            }
            queryParams.props = JSON.stringify(filters)
        }
        // Переходим на страницу объявлений.
        NavigationService.navigate(store.makeItemsListUrl(queryParams))
    })
}
